
/* injects from baggage-loader */

import React from "react";
import PropTypes from "prop-types";
import Zergling from "../../../../helpers/zergling";
import { t } from "../../../../helpers/translator";
import { addEventCompareConflicts } from "../../../../helpers/sport/betslip";
import { connect } from "react-redux";
import { UIMixin } from "../../../../mixins/uiMixin";
import { TitoCashoutAcceptBet } from "../../../../actions/terminal";
import Config from "../../../../config/main";
import SmartTable from "../../../../components/smartTable";
import { sportTicketsInfoColumnConfig } from "../constants/tableConfigs";
import { ticketScan } from "../../../../actions/ui";
import { toast } from "react-toastify";

class SportTicket extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scores: null,
      message: false,
      errMsg: null,
      newOdd: null,
      newCashoutAmount: null,
      newTicketObj: {},
      cashoutLoading: false,
    };
    this.copyToBetSlip = this.copyToBetSlip.bind(this);
    this.matchResult = this.matchResult.bind(this);
    this.getRefreshForBalance = this.getRefreshForBalance.bind(this);
    this.updateBet = this.updateBet.bind(this);
    this.earlyCashout = this.earlyCashout.bind(this);
    this.sportTicketsInfoColumnConfig = sportTicketsInfoColumnConfig.bind(this);
  }
  matchResult(gameIds) {
    Zergling.getresultV2(gameIds).then((data) => {
      // if (!Array.isArray(data.details))
      //     return toast.error(data.details);

      data.details &&
        data.details.length &&
        data.details.map((score) =>
          score.score && score.score.length !== 0
            ? this.setState({
                scores: {
                  ...this.state.scores,
                  [score.match_id]: score.score,
                  ...this.state.scores,
                },
              })
            : null
        );
    });
  }
  getRefreshForBalance(barcode) {
    Zergling.checkTerminalBetTicket(barcode, this.props.token).then((data) =>
      this.setState({ newCashoutAmount: data.data.cashout_amount })
    );
  }
  componentDidMount() {
    const { cashout_ticket, cashout_amount, event } = this.props;

    if (!cashout_ticket && event) {
      const arrIds = event.event.map((el) => el.match_id);
      this.matchResult(arrIds);
    }

    cashout_amount && this.setState({ newCashoutAmount: cashout_amount });
  }
  earlyCashout(e) {
    const { barcode } = this.props;
    const { cashoutLoading, newCashoutAmount } = this.state;

    if (cashoutLoading || !newCashoutAmount) return;

    e.stopPropagation();

    this.setState({ cashoutLoading: true }, () =>
      setTimeout(() => {
        // TODO Will be discussed
        this.props.dispatch(TitoCashoutAcceptBet({ barcode: barcode.toString(), amount: newCashoutAmount }));
      }, 100)
    );
  }
  updateBet(bet) {
    if (bet.data?.barcode) {
      const existingTicket = this.props.tickets?.[bet.data.barcode];
      this.setState(
        {
          newTicketObj: {
            [bet.data.barcode]: {
              cashout: false,
              bo_payment: false,
              amount: bet.data.win_amount,
              betAmount: bet.data.amount,
              betshop_id: bet.data.betshop_id,
              possibleWin: bet.data.possible_win,
              possible_tax_amount: bet.data.possible_tax_amount,
              tax_amount: bet.data.tax_amount,
              price: bet.data.price,
              sportBet: true,
              scaned_at: existingTicket?.scaned_at || Date.now(),
              events: {
                event: ((events) => {
                  let evs = [];
                  for (let key in events) {
                    if (events.hasOwnProperty(key)) {
                      let e = events[key];
                      e.__index__ = key;
                      e.coeficient = e.price;
                      e.game_name = e.match_name;
                      e.start_date_time = e.start_time;
                      e.event_name = e.display_market_name + "-" + e.display_selection_name;
                      e.outcome = e.state;
                      evs.push(e);
                    }
                  }
                  return evs;
                })(bet.data.selection_list),
              },
              created: bet.data.created,
              betType: bet.data.type_name,
              bet_state_id: bet.data.state_id,
              bet_state_name: bet.data.state_name,
              win_amount: bet.data.win_amount,
              barcode: bet.data.bar_code || bet.data.barcode,
              status: bet.data.state_id,
              cashout_amount: bet.data.cashout_amount,
            },
          },
        },
        () => this.props.dispatch(ticketScan({ ...this.state.newTicketObj }, true, bet.data.barcode))
      );
    }
  }
  componentDidUpdate(prevProps) {
    const { cashoutTicket: prevCashoutTicket } = prevProps;
    const { cashoutTicket } = this.props;

    const cashoutTicketData =
      cashoutTicket && (typeof cashoutTicket.Data === "object" ? cashoutTicket.Data.Id : cashoutTicket.Data);
    const prevCashoutTicketData =
      prevCashoutTicket &&
      (typeof prevCashoutTicket.Data === "object" ? prevCashoutTicket.Data.Id : prevCashoutTicket.Data);
    const pendingCashoutFinished = cashoutTicket && this.state.cashoutLoading;

    if (!prevCashoutTicket && cashoutTicket) {
      this.setState({
        cashoutButton: false,
        message: { [cashoutTicketData]: true, ...this.state.message },
        errMsg: null,
        newOdd: null,
      });
      return this.props.earlyCashoutBets(Number(cashoutTicketData));
    }

    if (
      prevCashoutTicket &&
      cashoutTicket &&
      !cashoutTicket.Message &&
      Number(prevCashoutTicketData) !== Number(cashoutTicketData)
    ) {
      this.setState({
        cashoutButton: false,
        cashoutLoading: false,
        message: { [cashoutTicketData]: true, ...this.state.message },
        errMsg: null,
        newOdd: null,
      });

      Zergling.checkTerminalBetTicket(this.props.barcode, this.props.token).then(this.updateBet);
      return this.props.earlyCashoutBets(Number(cashoutTicketData));
    }

    if (
      pendingCashoutFinished ||
      (cashoutTicket && prevCashoutTicket && cashoutTicketData === "CashoutBetFailed" && Number(prevCashoutTicketData))
    ) {
      return Zergling.checkTerminalBetTicket(this.props.barcode, this.props.token).then((data) => {
        this.setState({ newOdd: data.data, cashoutButton: false, cashoutLoading: false });
        this.updateBet(data);
      });
    }

    return;
  }
  copyToBetSlip(e, event) {
    e.stopPropagation();
    const command = (selections, games) => ({
      source: "betting",
      what: {
        sport: ["id", "alias"],
        region: ["id"],
        competition: ["id"],
        game: [],
        market: [],
        event: ["id", "order", "name", "price", "type", "base"],
      },
      where: { game: { id: { "@in": games } }, event: { id: { "@in": selections } } },
    });
    const eventIds = event.map((item) => item.selection_id);
    const matchIds = event.map((item) => item.match_id);
    Zergling.get(command(eventIds, matchIds)).then((data) => {
      Object.keys(data.data.sport)
        .filter((item) => Object.prototype.hasOwnProperty.call(data.data.sport, item))
        .map((item) => {
          const sport = data.data.sport[item];
          Object.keys(sport.region)
            .filter((item) => Object.prototype.hasOwnProperty.call(sport.region, item))
            .map((item) => {
              const region = sport.region[item];
              Object.keys(region.competition)
                .filter((item) => Object.prototype.hasOwnProperty.call(region.competition, item))
                .map((item) => {
                  const competition = region.competition[item];
                  Object.keys(competition.game)
                    .filter((item) => Object.prototype.hasOwnProperty.call(competition.game, item))
                    .map((item) => {
                      const game = competition.game[item];
                      Object.keys(game.market)
                        .filter((item) => Object.prototype.hasOwnProperty.call(game.market, item))
                        .map((item) => {
                          const market = game.market[item];
                          //this.props.betslipEventsCount.some(eventCount => eventCount === market ? console.log(eventCount, "DONE!!!!!!!!!") : "noooooooo");
                          Object.keys(market.event)
                            .filter((item) => Object.prototype.hasOwnProperty.call(market.event, item))
                            .map((item) => {
                              const event = market.event[item];
                              this.props.dispatch(
                                addEventCompareConflicts(
                                  {
                                    ...game,
                                    alias: sport.alias,
                                    regionId: region.id,
                                    competitionId: competition.id,
                                  },
                                  market,
                                  event,
                                  event.id
                                )
                              );
                            });
                        });
                    });
                });
            });
        });
    });
  }

  render() {
    const { newOdd, cashoutLoading, newCashoutAmount } = this.state;
    const { event, barcode } = this.props;

    const notResultedTicket = event?.event.some((item) => item.state_name === t("NotResulted"));

    const cashoutTicketMessage =
      Number(this.props.cashoutTicket?.Data) === this.props.barcode && this.props.cashoutTicket.Message;
    return (
      <div className="ticket-b-info-w-inside">
        {event && <SmartTable columnConfig={this.sportTicketsInfoColumnConfig()} data={event.event} />}

        {this.props.cashout || this.props.cashout_amount || notResultedTicket ? (
          <ul className="ticket-b-info-w-inside-inner">
            <div className="cashout-block">
              {newOdd?.barcode === barcode && !this.state.message[this.props.barcode] && !cashoutTicketMessage && (
                <p>{t(`New amount is available`)}&nbsp;</p>
              )}
              {cashoutTicketMessage ? (
                <p>{this.props.cashoutTicket.Message}</p>
              ) : !this.state.message || (this.state.message && !this.state.message[this.props.barcode]) ? (
                this.props.cashout &&
                !Config.main.disableCashoutBet && (
                  <div className="cashout-amount">
                    {cashoutLoading && (
                      <div className="sk-chase">
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                      </div>
                    )}

                    <div className="refresh-wrap">
                      <button
                        className="refresh-button"
                        onClick={() => this.getRefreshForBalance(this.props.barcode)}
                      ></button>
                      {newCashoutAmount && (
                        <i
                          className={`${
                            newCashoutAmount < this.props.cashout_amount
                              ? "top-m"
                              : newCashoutAmount < this.props.cashout_amount && "bot-m"
                          }`}
                        ></i>
                      )}
                      <span className="refresh-count">{newCashoutAmount}</span>
                    </div>
                    {!Config.main.disableCashoutBet && (
                      <button
                        className="cashout-bet"
                        onClick={this.earlyCashout}
                        disabled={cashoutLoading || !newCashoutAmount}
                      >
                        {t(`Cashout`)}
                      </button>
                    )}
                  </div>
                )
              ) : (
                this.state.message?.[this.props.barcode] && (
                  <p className="cashouted-bet">{t(`Your bet is successfully cashouted`)}</p>
                )
              )}
              {notResultedTicket && Config.enableCopyBetButton && (
                <button className="cashout-bet" onClick={(e) => this.copyToBetSlip(e, event.event)}>
                  {t(`Copy bet`)}
                </button>
              )}
            </div>
          </ul>
        ) : null}
      </div>
    );
  }
}
SportTicket.propTypes = {
  event: PropTypes.object,
  copyBet: PropTypes.bool,
  cashout: PropTypes.bool,
  barcode: PropTypes.number,
  cashout_amount: PropTypes.number,
  cashout_ticket: PropTypes.bool,
};
const mapStateToProps = (state) => {
  return {
    tickets: state.uiState.tickets,
    cashoutTicket: state.uiState.cashoutTicket,
    token: state.terminal.authData.token,
  };
};
export default connect(mapStateToProps)(UIMixin({ Component: SportTicket }));
